import { FC, ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import { v4 as uuid } from 'uuid';
import SearchBar from '../searchBar/SearchBar';
import EditIcon from '../../assets/images/catalogue/EditIcon';
import UserProfileSummary from '../UserProfileSummary/UserProfileSummary';
import BordLogo from '../BordLogo/BordLogo';
import './Header.scss';

interface IButton {
  title?: string;
  route?: string;
  color?: string;
  icon?: ReactNode;
  action?: () => void;
  identificator?: string;
  customClassName?: string;
  customClassNameContainer?: string;
}
interface IHeaderInfo {
  title: string;
  subtitle: string;
  titleRoute?: string;
  headerNote?: string;
}

interface ISharedModules {
  title: string;
  key: number;
  active: boolean;
}

interface IHeader {
  title?: string;
  subtitle?: string;
  headerInfo?: IHeaderInfo;
  buttonsHeader?: IButton[];
  viewSearchBar?: boolean;
  searchBarDropdownList?: JSX.Element;
  searchText?: string;
  searchbarPlaceholder?: string;
  setSearchText?: (text: string) => void;
  buttonDisabled?: boolean;
  sharedModules?: ISharedModules[];
  sharedModulesAction?: (key: number) => void;
  sharedModule?: ISharedModules;
  loadingSearchBar?: boolean;
  customClassNameButtonMenu?: string;
  custonMarginRightButtonsContainer?: string;
}

const Header: FC<IHeader> = ({
  headerInfo,
  buttonsHeader,
  viewSearchBar,
  searchBarDropdownList,
  searchText,
  searchbarPlaceholder,
  setSearchText,
  buttonDisabled,
  sharedModules,
  sharedModulesAction,
  sharedModule,
  loadingSearchBar,
  customClassNameButtonMenu = '',
  custonMarginRightButtonsContainer = ''
}: IHeader) => {
  const { push } = useHistory();

  const handleClickRoute = (route: string) => push(route);
  const handleClickAction = (action: () => void) => action();
  const marginRightButtonsContainer =
    custonMarginRightButtonsContainer || (sharedModules && !!sharedModules?.length ? '200px' : '');

  const generateButtons = () => {
    return buttonsHeader?.map((item: IButton) => {
      return (
        <Button
          onClick={() => {
            if (item?.route) {
              handleClickRoute(item?.route);
            } else if (item?.action) {
              handleClickAction(item?.action);
            }
          }}
          disabled={item.identificator === 'save' && buttonDisabled}
          key={uuid()}
          className={`${item?.customClassName ? item?.customClassName : 'buttonHeader'} ${
            item.color || 'grayButton'
          } ${customClassNameButtonMenu}`}
          icon={
            item.identificator === 'save' && buttonDisabled && !item?.customClassNameContainer ? (
              <div className="iconStyle">
                <EditIcon stroke="#B3B3B3" fill="#ececec" className="iconPositionButton" />
              </div>
            ) : (
              !item?.customClassNameContainer && item?.icon
            )
          }
        >
          {item?.customClassNameContainer ? (
            <div className={item?.customClassNameContainer}>
              <div>{item.title}</div>
              <div>{item?.icon}</div>
            </div>
          ) : (
            item.title
          )}
        </Button>
      );
    });
  };

  return (
    <div id="header">
      <div className="iconHeader">
        <BordLogo colorLetters="#070F21" standardSize={48} colorDot="#FF6175" />
      </div>
      <div className="contentHeader">
        <div className="containerMainInfo">
          <div className="containerInfoMenu">
            {headerInfo?.title && (
              <div
                className="title"
                onClick={() => {
                  if (headerInfo?.titleRoute) handleClickRoute(headerInfo?.titleRoute);
                }}
              >
                {headerInfo?.title || 'title'}
              </div>
            )}
            {headerInfo?.subtitle && <div className="subtitle">{headerInfo?.subtitle || 'subtitle'}</div>}
            {headerInfo?.headerNote && <div className="headerNote">{headerInfo?.headerNote}</div>}
          </div>
        </div>
        <div
          className="buttonsContainer"
          style={{
            marginRight: marginRightButtonsContainer
          }}
        >
          {(viewSearchBar || searchBarDropdownList) && (
            <div className="containerSearchBar">
              {searchBarDropdownList && searchBarDropdownList}
              <SearchBar
                searchText={searchText}
                setSearchText={setSearchText}
                customPlaceholder={searchbarPlaceholder}
                loadingSearchBar={loadingSearchBar}
              />
            </div>
          )}
          {buttonsHeader && !!buttonsHeader.length && generateButtons()}
          {sharedModules && !!sharedModules.length && (
            <div className="containerSharedModules">
              {sharedModules.map(item => {
                return (
                  <div
                    key={`shared-module-${item.key}`}
                    className={`buttonMenu ${
                      item.key === sharedModule?.key ? 'activeModule' : 'inactiveModule'
                    } ${customClassNameButtonMenu}`}
                    onClick={() => {
                      if (sharedModulesAction && item.key !== sharedModule?.key) sharedModulesAction(item.key);
                    }}
                  >
                    {item.title}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <UserProfileSummary />
      </div>
    </div>
  );
};
export default Header;
